module.exports = __webpack_public_path__ + "img/Dusshera 3.42effc8d.jpeg";